import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ITrackingShopContext } from '@x/common/tracking/tracking.module.config';
import { AuthState } from '@x/ecommerce-shop/app/core/auth/state/auth.state';
import { IShopConfig, SHOP_CONFIG } from '@x/ecommerce-shop/config/shop.config';
import { IShopAuthUser } from '@x/ecommerce/shop-client';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TrackingShopContextService implements ITrackingShopContext {
  user$: Observable<IShopAuthUser | null> = this.store.select(AuthState.loggedInUser);
  brand: string = this.shopConfig.brand.shortName;
  flavor: string = this.shopConfig.flavor;
  defaultCountry = this.shopConfig.defaultCountry;

  constructor(
    @Inject(SHOP_CONFIG) private shopConfig: IShopConfig,
    private store: Store
  ) {}
}
